export enum ToastVmIcons {
  PulsingExclamationMark = 'pulsing-white-exclamation-mark',
  PulsingOwl = 'owl-pulsing-icon'
}
